import { db, getDeviceId } from "../db/database";

interface ApiOptions extends RequestInit {
  anonymous?: boolean;
}

export async function apiRequest<T = unknown>(path: string, options: ApiOptions = {}): Promise<T> {
  const settings = await db.settings.get("app");
  const apiUrl = settings?.apiUrl?.replace(/\/$/, "");
  if (!apiUrl) throw new Error("A URL da API ainda não foi configurada.");
  if (!navigator.onLine) throw new Error("Sem conexão com a internet.");

  const session = options.anonymous ? undefined : await db.sessions.get("current");
  const headers = new Headers(options.headers);
  headers.set("Content-Type", "application/json");
  headers.set("Accept", "application/json");
  headers.set("X-Device-Id", await getDeviceId());
  if (session?.accessToken) headers.set("Authorization", `Bearer ${session.accessToken}`);

  const response = await fetch(`${apiUrl}${path}`, {
    ...options,
    headers,
    cache: "no-store",
  });
  const data = await response.json().catch(() => ({ message: "Resposta inválida do servidor." }));
  if (!response.ok) {
    throw new Error(data.message || `Falha na API (${response.status}).`);
  }
  return data as T;
}
